import SurveyEditor from '@/components/survey/SurveyEditor'
export default {
  name: 'edit',
  components: {SurveyEditor},
  props: [],
  data () {
    return {
      survey: {},
      errors: [],
      btn_submit: false
    }
  },
  computed: {

  },
  mounted () {
    this.$loading.start()
    this.$store.dispatch('Survey/showSurvey', {survey_id: this.$route.params.survey_id}).then(res => {
      this.$loading.complete()
      this.survey = res
      this.survey.is_private = this.survey.is_private ? 1 : 0
    }).catch(errors => {
      this.$loading.fail()
    })
  },
  methods: {
    showModal (json) {
      if (json.length) {
        this.survey.content = json
        this.$refs.createForm.show()
      } else {
        alert('chưa có nội dung')
      }
    },
    save () {
      // data to upload (survey {})
      this.$loading.start()
      // this.survey.status = 1
      this.$store.dispatch('Survey/updateSurvey', {survey: this.survey}).then(res => {
        this.$loading.complete()
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        this.$router.push('/survey/list')
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.$loading.fail()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/survey/edit/edit.js